// ULID — Universally Unique Lexicographically Sortable Identifier.
// 26 chars Crockford base32: 10 chars timestamp (48 bits ms) + 16 chars random (80 bits).
// Sortable por timestamp asc, único cross-device sin coordinación.
//
// Spec: https://github.com/ulid/spec
const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const ENCODING_LEN = ENCODING.length;
const TIME_LEN = 10;
const RANDOM_LEN = 16;

function encodeTime(now: number, len: number): string {
  let mod;
  let str = '';
  for (let i = len - 1; i >= 0; i--) {
    mod = now % ENCODING_LEN;
    str = ENCODING.charAt(mod) + str;
    now = (now - mod) / ENCODING_LEN;
  }
  return str;
}

function encodeRandom(len: number): string {
  const bytes = new Uint8Array(len);
  globalThis.crypto.getRandomValues(bytes);
  let str = '';
  for (let i = 0; i < len; i++) {
    str += ENCODING.charAt(bytes[i] % ENCODING_LEN);
  }
  return str;
}

export function ulid(now?: number): string {
  return encodeTime(now ?? Date.now(), TIME_LEN) + encodeRandom(RANDOM_LEN);
}

// Devuelve los ms del timestamp embebido en el ULID. Útil para ordenar por t real.
export function ulidTimestamp(id: string): number {
  if (id.length < TIME_LEN) return 0;
  let t = 0;
  for (let i = 0; i < TIME_LEN; i++) {
    const c = id.charAt(i);
    const idx = ENCODING.indexOf(c);
    if (idx < 0) return 0;
    t = t * ENCODING_LEN + idx;
  }
  return t;
}
